<template>
    <div class="cursor-pointer relative h-4 h-4" @click="toggle" title="Подписаться на новые комментарии">
        <div v-if="status"
             class="w-2 h-2 rounded-full bg-red-500 ring ring-red-500/10 absolute -top-0.5 -right-0.5"></div>
        <svg-icon v-if="status" icon="bell-fill" class="w-4 h-4 text-blue-500"></svg-icon>
        <svg-icon v-else icon="bell" class="w-4 h-4 opacity-50 hover:opacity-100"></svg-icon>
    </div>
</template>
<script>

import SvgIcon from "../partials/SvgIcon.vue";
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";

export default {
    name: 'PostSubscribe',
    components: {SvgIcon},
    props: {
        postid: {
            type: Number,
            required: true,
        },
        subscribed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            status: this.subscribed,
        }
    },
    methods: {
        toggle() {
            if (this.status) {
                this.unsubscribe();
            } else {
                this.subscribe();
            }
        },
        subscribe() {
            Client.post('/api/v1.1/posts/' + this.postid + '/subscribe')
                .then(response => {
                    this.status = true;
                    notify({
                        type: 'success',
                        text: 'Вы подписались на комментарии',
                    });
                })
                .catch(error => {
                    notify({
                        type: 'error',
                        text: 'Не удалось подписаться на комментарии',
                    });
                });
        },
        unsubscribe() {
            Client.delete('/api/v1.1/posts/' + this.postid + '/subscribe')
                .then(response => {
                    this.status = false;
                    notify({
                        type: 'success',
                        text: 'Вы отписались от комментариев',
                    });
                })
                .catch(error => {
                    notify({
                        type: 'error',
                        text: 'Не удалось отписаться от комментариев',
                    });
                });
            this.status = false;
        }
    },
}
</script>